import * as Yup from 'yup';
import { telephoneValidationSchema } from '../../../helpers/validationHelper';

const FieldConfigs = [
  {
    name: 'firstName',
    label: 'First Name',
    placeholder: 'Enter first name',
    autoFocus: true,
    colSpan: 6,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    placeholder: 'Enter last name',
    colSpan: 6,
  },
  {
    name: 'telephone',
    label: 'Telephone',
    placeholder: 'Enter telephone number',
    type: 'tel',
    colSpan: 6,
  },
];

const DoubleFactorAuthEnabledConfiguration = [
  {
    name: 'emailPasscodeEnabled',
    label: 'Email passcode enabled',
    type: 'checkbox',
    colSpan: 6,
  },
];

const ValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First name is required')
    .max(50, 'Must be less than 50 character.'),
  lastName: Yup.string()
    .required('Last name is required')
    .max(50, 'Must be less than 50 character.'),
  emailPasscodeEnabled: Yup.boolean(),
  telephone: telephoneValidationSchema(),
  //Yup.string().matches(ukPhoneRegExp, 'Phone number is not valid').
});

export { FieldConfigs, DoubleFactorAuthEnabledConfiguration, ValidationSchema };
